import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const UnassortedShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Unassorted Section"
    sectionKey="Unassorted"
    backRoute="/sections/unassorted"
  />
);

export default UnassortedShipmentRequest;
